export interface FieldPathRead {
  value: unknown;
  missing: boolean;
}

export function readFieldPath(root: unknown, fieldPath: string | null | undefined): FieldPathRead {
  if (!fieldPath) return { value: root, missing: false };
  const parts = fieldPath.split('.').filter(Boolean);
  let current: unknown = root;
  for (const part of parts) {
    if (current == null) return { value: undefined, missing: true };
    if (Array.isArray(current)) {
      const index = Number(part);
      if (!Number.isInteger(index) || index < 0 || index >= current.length) {
        return { value: undefined, missing: true };
      }
      current = current[index];
      continue;
    }
    if (typeof current !== 'object') return { value: undefined, missing: true };
    const record = current as Record<string, unknown>;
    if (!Object.prototype.hasOwnProperty.call(record, part)) {
      return { value: undefined, missing: true };
    }
    current = record[part];
  }
  return { value: current, missing: false };
}

export function toSnapshotValue(value: unknown): unknown {
  if (value == null) return null;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) {
    return value.map((item) => toSnapshotValue(item));
  }
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {};
    Object.entries(value as Record<string, unknown>).forEach(([key, item]) => {
      if (typeof item !== 'undefined' && typeof item !== 'function') {
        out[key] = toSnapshotValue(item);
      }
    });
    return out;
  }
  return String(value);
}

export function formatFieldValue(value: unknown, missing = false): string {
  if (missing) return '[field missing]';
  if (typeof value === 'string') return value;
  if (typeof value === 'undefined') return '[undefined]';
  if (value === null) return 'null';
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
